module.exports = __webpack_public_path__ + "static/img/110116.42773012.png";